export const IDENTITY_APPLICATION_ID = process.env.REACT_APP_IDENTITY_APPLICATION_ID || '43833997-5cc0-11eb-97b9-0ab31cf82f57';
